// TODO: Review z-index usage. Apparently it was needed because of lack of stacking contexts
export const Z_INDEX = {
  /* Layout -- ROOT VALUES 1x, 2x, etc...*/
  MOBILE_PAGE_OVERLAY: 10,

  /* PDF Objects */
  FORM_FIELDS: 2,
  UNEDITED_TEXT: 2,
  FORM_FIELD_TO_INSERT: 3,
  SHAPES: 3,
  EDITED_TEXT: 4,

  /* Utility Items */
  RESIZE_HANDLES: 9,
};
